function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.66667 2.33333H12.25V3.5H4.66667V2.33333ZM2.91667 1.75V3.5H3.5V4.08333H1.75V3.5H2.33333V2.33333H1.75V1.75H2.91667ZM1.75 8.16667V6.70833H2.91667V6.41667H1.75V5.83333H3.5V7.29167H2.33333V7.58333H3.5V8.16667H1.75ZM2.91667 11.375H1.75V10.7917H2.91667V10.5H1.75V9.91667H3.5V12.25H1.75V11.6667H2.91667V11.375ZM4.66667 6.41667H12.25V7.58333H4.66667V6.41667ZM4.66667 10.5H12.25V11.6667H4.66667V10.5Z",
  fill: "currentColor"
});

var SvgOrderedlist = function SvgOrderedlist(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOrderedlist, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/orderedlist.bd00d6ab.svg";
export { ForwardRef as ReactComponent };